import { ProductConnectivityState, ProductPeripheralsState, Workspace } from 'zens-store'
import { Color } from 'zens-storybook'

export const careStatusColors = {
  offline: Color.red,
  connectivityLost: Color.collCopper,
  connectivityUnknown: Color.calmGrey,
  connected: Color.green,
  sensorDisconnected: Color.darkerBlue,
  ledDisconnected: Color.yellow,
  sensorAndLedDisconnected: Color.purple,
  peripheralsUnknown: Color.graphiteGrey,
  outsideZone: Color.greyBlue,
}

export function colorForCareWorkspaceStatus(workspace: Pick<Workspace, 'connectivityState' | 'peripheralsState'>) {
  switch (workspace.connectivityState) {
    case ProductConnectivityState.Disconnected:
      return careStatusColors.offline
    case ProductConnectivityState.ConnectivityLost:
      return careStatusColors.connectivityLost
    case ProductConnectivityState.Connected:
      break
    default:
      return careStatusColors.connectivityUnknown
  }

  switch (workspace.peripheralsState) {
    case ProductPeripheralsState.Connected:
      return careStatusColors.connected
    case ProductPeripheralsState.SensorDisconnected:
      return careStatusColors.sensorDisconnected
    case ProductPeripheralsState.LedDisconnected:
      return careStatusColors.ledDisconnected
    case ProductPeripheralsState.SensorAndLedDisconnected:
      return careStatusColors.sensorAndLedDisconnected
    default:
      return careStatusColors.peripheralsUnknown
  }
}
